import { iconHelp } from '../components/iconHelp';
import { iconShipping } from '../components/iconShipping';
/* eslint-disable */
export const callOutsStyle = ({ page, showHelp = true }) => {
	const maybeHelp = page.querySelector('.c7-callout');
	if (maybeHelp && !maybeHelp.classList.contains('c7-callout--club')) {
		maybeHelp.style = 'display: none;';
	}

	const { shipping_info: { title, paragraph } } = template;
	const helpContainer = document.createElement('div');
	helpContainer.classList = 'info-container grid gap-4 grid-cols-1 mt-6 p-12';
	showHelp && (helpContainer.classList += ' lg:grid-cols-2 bg-[#E6E4D1]')
	!showHelp && (helpContainer.classList += ' bg-[#F0EFE7]')
	helpContainer.insertAdjacentHTML('afterbegin', `
	<div class="p-8 ${showHelp ? 'bg-[#FFFDF5]' : 'bg-[#FBF9F0]'} border border-[#EAEAEA] text-base text-brown">
		${iconShipping({ props: 'class="mb-6" style="width: auto; height: auto; stroke: none; stroke-width: 0;"' })}
		<h4 class="text-2xl font-semibold headlines-font uppercase mb-6 text-brown">${title}</h4>
		<p class="mb-6">${paragraph}</p>
	</div>
	`);

	const { maybe_help_info: { title: helpTitle, paragraph: helpParagraph } } = template;
	showHelp && helpContainer.insertAdjacentHTML('beforeend', `
	<div class="p-8 bg-[#FFFDF5] border border-[#EAEAEA] text-base text-brown">
		${iconHelp({ props: 'class="mb-6" style="width: auto; height: auto; stroke: none; stroke-width: 0;"' })}
		<h4 class="text-2xl font-semibold headlines-font uppercase mb-6 text-brown">${helpTitle}</h4>
		<p class="mb-6">${helpParagraph}</p>
		<a href="${template.faqs_page}" class="uppercase text-yellow font-bold text-base mt-6 inline-block">Go to Faqs</a>
	</div>
	`);

	page.appendChild(helpContainer);
}